import { DataProvider } from "@shared/constants/common";
import { useMemo } from "react";
import { useStore } from "@shared/store/useStore";
import { TicketBasketType } from "@shared/modules/payments/types";

export function useVenueBasketField(field: keyof TicketBasketType) {
  return useBasketField(DataProvider.Venue, field);
}

export function usePublicBasketField(field: keyof TicketBasketType) {
  return useBasketField(DataProvider.Public, field);
}

function useBasketField(type: DataProvider, field: keyof TicketBasketType) {
  const basket: TicketBasketType | undefined = useStore((state) =>
    state.getBasket(type)
  );

  return useMemo(() => {
    return basket ? basket[field] : undefined;
  }, [basket, field]); // Reactively update when basket or field changes
}
